export default "__VITE_ASSET__8f203770__"